/** Copia adaptada de apps/builder-spa/src/api/users.ts. */
import { apiFetch } from './apiClient.js';

export type UserRole = 'admin' | 'editor' | 'agent' | 'viewer' | 'platform-ops';

export interface TenantUser {
  username: string;
  sub: string;
  email: string;
  displayName?: string;
  tenantId: string;
  roles: UserRole[];
  status?: string;
  enabled?: boolean;
  createdAt?: string;
  lastModifiedAt?: string;
}

export interface CreateTenantUserBody {
  email: string;
  displayName?: string;
  roles: UserRole[];
}

export interface UpdateTenantUserBody {
  displayName?: string;
  roles?: UserRole[];
  enabled?: boolean;
}

export async function listUsers(tenantId: string): Promise<TenantUser[]> {
  const res = await apiFetch<{ items: TenantUser[] }>(
    `/v1/tenants/${encodeURIComponent(tenantId)}/users`,
  );
  return res.items;
}

export async function createUser(
  tenantId: string,
  body: CreateTenantUserBody,
): Promise<TenantUser> {
  return apiFetch<TenantUser>(`/v1/tenants/${encodeURIComponent(tenantId)}/users`, {
    method: 'POST',
    body,
  });
}

export async function updateUser(
  tenantId: string,
  username: string,
  patch: UpdateTenantUserBody,
): Promise<TenantUser> {
  return apiFetch<TenantUser>(
    `/v1/tenants/${encodeURIComponent(tenantId)}/users/${encodeURIComponent(username)}`,
    { method: 'PATCH', body: patch },
  );
}

export async function deleteUser(tenantId: string, username: string): Promise<void> {
  await apiFetch<void>(
    `/v1/tenants/${encodeURIComponent(tenantId)}/users/${encodeURIComponent(username)}`,
    { method: 'DELETE' },
  );
}

export async function resetUserPassword(tenantId: string, username: string): Promise<void> {
  await apiFetch<void>(
    `/v1/tenants/${encodeURIComponent(tenantId)}/users/${encodeURIComponent(username)}/reset-password`,
    { method: 'POST' },
  );
}
